import { getRequest } from '../../services/httpService';
import { PaginatedResponse } from '../../types';

export function getReportDataProcedureList({url}:{url?:string}): Promise<PaginatedResponse<object[]>> {
  return getRequest<PaginatedResponse<object[]>>(url ?? '', { responseType: 'json' });
}

export function getReportDataDrugs({url, patientId}:{url?:string, patientId?:string}): Promise<PaginatedResponse<object[]>> {
  // Construct the URL with the patientId if provided
  if (patientId) {
    url = `${url}?patient=${patientId}`;
  }
  // Call the API with the constructed URL
  return getRequest<PaginatedResponse<object[]>>(url ?? '', { responseType: 'json' });
}